export default __webpack_public_path__ + "static/media/dessert_bg.32b7bbfb.jpg";